"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'Toggle'
});
schema.propTypes = {
  defaultSelected: _reactDesc.PropTypes.string.description('The ID of the option that should be selected by default. If not provided, will default to the first option.'),
  disabled: _reactDesc.PropTypes.bool.description('A boolean controlling whether the Toggle is disabled.'),
  name: _reactDesc.PropTypes.string.description("The name of the toggle input. If used within a form, the selected option's ID will be the value associated with the name").isRequired,
  onChange: _reactDesc.PropTypes.func.description('A function called when the toggle is switched. It is called with the ID of the newly selected option'),
  options: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    id: _reactDesc.PropTypes.string.description('The ID of the option').isRequired,
    text: _reactDesc.PropTypes.string.description('The label that will be displayed for the option. Ignore if you want to hide the label.')
  })).description('A two element array where each element represents an option in the Toggle').isRequired,
  readOnly: _reactDesc.PropTypes.bool.description('A boolean controlling whether the Toggle is read only.'),
  selected: _reactDesc.PropTypes.string.description('The ID of the option that is selected. If provided, controlling the Toggle must be handled externally. Overrides `defaultSelected`.'),
  size: _reactDesc.PropTypes.oneOf(['small', 'medium']).description('Sets the size of the Toggle').defaultValue('medium')
};
var _default = schema;
exports.default = _default;